import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
import { Navigation } from './components/Navigation';
import { Dashboard } from './components/Dashboard';
import { WorkersPage } from './pages/WorkersPage';
import { InspectionsPage } from './pages/InspectionsPage';
import { DocumentsPage } from './pages/DocumentsPage';
import { BiltonAIPage } from './pages/BiltonAIPage';
import { PreShiftPage } from './pages/PreShiftPage';
import { ToolboxTalkPage } from './pages/ToolboxTalkPage';
import { JHAPage } from './pages/JHAPage';
import { PTPPage } from './pages/PTPPage';
import { ProjectFilterProvider } from './contexts/ProjectFilterContext';
import { ContractorFilterProvider } from './contexts/ContractorFilterContext';
import { BiltonAIProvider } from './contexts/BiltonAIContext';
import { KPIProvider } from './contexts/KPIContext';
import { PreventionModelProvider } from './contexts/PreventionModelContext';
// Layout wrapper for pages other than Dashboard (which handles its own layout now)
function PageLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen bg-[#fafafa] flex" data-id="element-0">
      <Navigation data-id="element-1" />
      <div className="flex-1 flex flex-col min-w-0 h-screen overflow-hidden" data-id="element-2">
        <main className="flex-1 overflow-y-auto overflow-x-hidden relative" data-id="element-3">
          {children}
        </main>
      </div>
    </div>;
}
export function App() {
  return <BrowserRouter data-id="element-4">
      <ScrollToTop data-id="element-5" />
      <BiltonAIProvider data-id="element-6">
        <ProjectFilterProvider data-id="element-7">
          <ContractorFilterProvider data-id="element-8">
            <KPIProvider data-id="element-9">
              <PreventionModelProvider data-id="element-10">
                <Routes data-id="element-11">
                  <Route path="/" element={<Dashboard data-id="element-13" />} data-id="element-12" />
                  <Route path="/bilton-ai" element={<PageLayout data-id="element-15">
                        <BiltonAIPage data-id="element-16" />
                      </PageLayout>} data-id="element-14" />
                  <Route path="/workers" element={<PageLayout data-id="element-18">
                        <WorkersPage data-id="element-19" />
                      </PageLayout>} data-id="element-17" />
                  <Route path="/inspections" element={<PageLayout data-id="element-21">
                        <InspectionsPage data-id="element-22" />
                      </PageLayout>} data-id="element-20" />
                  <Route path="/documents" element={<PageLayout data-id="element-24">
                        <DocumentsPage data-id="element-25" />
                      </PageLayout>} data-id="element-23" />
                  <Route path="/pre-shift" element={<PageLayout data-id="element-27">
                        <PreShiftPage data-id="element-28" />
                      </PageLayout>} data-id="element-26" />
                  <Route path="/toolbox-talk" element={<PageLayout data-id="element-30">
                        <ToolboxTalkPage data-id="element-31" />
                      </PageLayout>} data-id="element-29" />
                  <Route path="/jha" element={<PageLayout data-id="element-33">
                        <JHAPage data-id="element-34" />
                      </PageLayout>} data-id="element-32" />
                  <Route path="/ptp" element={<PageLayout data-id="element-36">
                        <PTPPage data-id="element-37" />
                      </PageLayout>} data-id="element-35" />
                </Routes>
              </PreventionModelProvider>
            </KPIProvider>
          </ContractorFilterProvider>
        </ProjectFilterProvider>
      </BiltonAIProvider>
    </BrowserRouter>;
}